export default {
  nav_home: 'Home',
  nav_contact: 'Contact',

  nav_about: 'Over Ons',
  get_early_access: 'Neem contact op',
  hero_title: 'Brainsoft ICT is hard aan het werk om u een vernieuwde online ervaring te bieden.',
  hero_subtitle: 'Ontdek binnenkort onze geoptimaliseerde diensten voor cloudbeheer en softwareontwikkeling.',

  // Services
  services_title: 'Onze Diensten',
  service_managed_title: 'Managed Services via de Cloud',
  service_managed_desc: 'Professioneel beheer van uw endpoints en databases via de cloud. Wij zorgen voor betrouwbare, veilige en schaalbare oplossingen die uw bedrijf ondersteunen.',
  service_development_title: 'Development',
  service_development_desc: 'Op maat gemaakte softwareontwikkeling en digitale oplossingen. Van webapplicaties tot complexe systemen, wij realiseren uw digitale ambities.',

  // Contact
  contact_title: 'Neem contact met ons op',
  contact_subtitle: 'Heeft u vragen of wilt u meer informatie? Vul het formulier in en wij nemen zo snel mogelijk contact met u op.',
  form_name: 'Naam',
  form_email: 'E-mailadres',
  form_phone: 'Telefoonnummer',
  form_message: 'Bericht',
  form_submit: 'Verstuur bericht',
  form_success: 'Bedankt voor uw bericht! Wij nemen spoedig contact met u op.',
  form_success_secondary: 'We laten u weten zodra we live gaan.',
  form_error: 'Er is iets misgegaan. Probeer het later opnieuw.',

  // About
  about_page_title: 'Over Brainsoft ICT',
  about_page_subtitle: 'Wij zijn een toegewijd team van IT-professionals die bedrijven helpen met innovatieve technologische oplossingen. Met jarenlange ervaring in cloud services en softwareontwikkeling, staan wij klaar om uw digitale transformatie te realiseren.',
  team_title: 'Ons Team',
  team_role_1: 'Directeur & CTO',
  team_role_2: 'System Engineer',
  team_role_3: 'Bestuurslid',
  team_role_4: 'Bestuurslid',
  team_role_5: 'Trainee',
  about_cta_title: 'Klaar om samen te werken?',
  about_cta_subtitle: 'Neem contact met ons op en ontdek hoe Brainsoft ICT uw bedrijf kan helpen groeien met de juiste IT-oplossingen.',

  about_title: 'Over Brainsoft ICT',
  about_text: 'Brainsoft ICT is uw partner voor innovatieve IT-oplossingen en digitale transformatie.',
  footer_rights: '© 2026 Brainsoft ICT. Alle rechten voorbehouden.',
  footer_kvk: 'KVK: 82383650',
  footer_btw: 'BTW: NL862445784B01',
  coming_soon: 'Binnenkort beschikbaar'
};